var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAccountDashboard = function SvgIconAccountDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.501 8.705V16.5c0 .46-.373.834-.833.834H2.335A.833.833 0 0 1 1.5 16.5V8.705A3.32 3.32 0 0 1 .668 6.5v-5c0-.46.373-.833.833-.833h15c.46 0 .834.373.834.833v5a3.32 3.32 0 0 1-.834 2.205M14.835 9.73A3.34 3.34 0 0 1 11.5 8.705a3.33 3.33 0 0 1-2.5 1.129c-.995 0-1.889-.437-2.5-1.129A3.33 3.33 0 0 1 3.168 9.73v5.938h11.667zM10.668 6.5a.833.833 0 1 1 1.667 0 1.667 1.667 0 1 0 3.333 0V2.334H2.335V6.5a1.667 1.667 0 1 0 3.333 0 .833.833 0 1 1 1.667 0 1.667 1.667 0 1 0 3.333 0"
  })));
};
export default SvgIconAccountDashboard;